module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.activeLock) ? _c('div', {
    class: {
      wrap: true, marked: (_vm.seconds < 60)
    }
  }, [_vm._v("\n  Ditt bokning är reserverad. Du behöver slutföra din bokning innan följande tid är slut: "), _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.time))]), _vm._v("\n   "), (true) ? _c('button', {
    staticClass: "small white border",
    on: {
      "click": function($event) {
        return _vm.extend_time()
      }
    }
  }, [_vm._v("Förläng")]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-426f8f14"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/BookingTimer.vue
// module id = 942
// module chunks = 0